import React, { useState, useEffect, useRef } from 'react';
import { Typography, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { flowValidationAtom } from '../../../../Services/_states';
import SearchableDropdown from '../../Common/SearchableDropdown/SearchableDropdown.tsx';

interface SuggetionObj {
  label: string;
  value: string;
}

const OpenAINode = ({ data }: any) => {
  const flowValidationObj = useRecoilValue(flowValidationAtom);
  const [selectedOption, setSelectedOption] = useState('GPT 4.0');
  const [value, setValue] = useState({ label: 'GPT 4.0', value: 'gpt-4' }); 

  // State for body text
  const [bodyText, setBodyText] = useState(data?.body || '');
  
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Update the bodyText state when the data.body prop changes
  useEffect(() => {
    if (data.body !== bodyText) {
      setBodyText(data.body || '');
    }
  }, [data.body]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 12}px`;
    }
  }, [bodyText]);

  const handleBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setBodyText(value);

    const instruction = value;


    // Detect `{{@` pattern for suggestions, etc.
    const cursorPos = e.target.selectionStart;
    const textBeforeCursor = value.slice(0, cursorPos);
    
    // Detect `{{@` pattern
    const match = textBeforeCursor.match(/{{@(\w*)$/);
    if (match) {
      // Handle matching pattern logic here...
    }

    // Update parent data
    data.onChange(data.id, { body: value, instruction });
  };

  const handleOptionChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedOption(event.target.value as string);
    const selectedModel = event.target.value as string;
    data.onChange(data.id, { selectedModel });
  };

  const options = [
    { label: 'GPT 4.0', value: 'gpt-4' },
    { label: 'GPT 3.5', value: 'gpt-3.5' },
    { label: 'GPT 3.0', value: 'gpt-3.0' },
  ];

  const handleDropdownChange = (selectedValue: any) => {
    setValue(selectedValue);
  };

  return (
    <div>
      {/* Header and Footer sections commented out */}
      {/* 
      <div style={{ marginBottom: '10px', position: 'relative' }}>
        <label>Header:</label>
        <input
          type="text"
          value={data.header || ''}
          onChange={(e) => data.onChange(data.id, { header: e.target.value })}
        />
      </div>
      <div style={{ marginBottom: '10px', position: 'relative' }}>
        <label>Footer:</label>
        <input
          type="text"
          value={data.footer || ''}
          onChange={(e) => data.onChange(data.id, { footer: e.target.value })}
        />
      </div>
      */}

    <label>Select GPT Model:</label>
      <SearchableDropdown
        options={options}
        label="Select GPT Model"
        labelKey="label"
        value={value}
        onChange={handleDropdownChange} 
        loading={false}
        multiSelect={false}
        error={false}
        errorMessage="Invalid model selection"
        getOptionLabel={(option: any) => option.label}
        size="small"
        sx={{ marginTop: '5px' }}
        disabled={true}  
      />

      <label>Instruction:</label>
      <div style={{ position: 'relative' }}>
        <textarea
          ref={textareaRef}
          value={bodyText || ''}
          onChange={handleBodyChange}
          placeholder="Enter text"
          maxLength={4096}
          style={{
            width: '100%',
            height: 'auto',
            padding: '5px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            background: '#f5f5f5',
            overflow: 'hidden',
            resize: 'none',
          }}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            bottom: '10px',
            fontSize: '12px',
            color: bodyText.length === 4096 ? 'red' : '#888',
          }}
        >
          {`${bodyText.length}/4096`}
        </span>
      </div>
      {flowValidationObj[data?.id]?.body && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {flowValidationObj[data?.id]?.body}
        </Typography>
      )}

      {/* Suggestions Dropdown (if needed) */}
      {/* {showSuggestions && data?.parentResults?.length > 0 && (
        <div
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: 4,
            zIndex: 1000,
            width: '100%',
          }}
        >
          {data?.parentResults?.map((suggestion: SuggetionObj, index: number) => (
            <div
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              style={{
                padding: '5px 10px',
                cursor: 'pointer',
                backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff',
              }}
            >
              {suggestion?.label}
            </div>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default OpenAINode;
